import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ReasonModal = ({ show, onHide, onSubmit, type, record }) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (record && type) {
      const reasonField = `${type}Reason`;
      const initialReason = record[reasonField] || '';
      setReason(initialReason);
    }
  }, [record, type]);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      alert('Please provide a reason');
      return;
    }
    setLoading(true);
    await onSubmit(reason);
    setLoading(false);
    onHide();
  };

  const getTitle = () => {
    switch (type) {
      case 'late':
        return 'Late Arrival Approval Form';
      case 'earlyClose':
        return 'Early Leave Approval Form';
      case 'overtime':
        return 'Overtime Approval Form';
      default:
        return 'Approval Form';
    }
  };

  const getFieldLabel = () => {
    switch (type) {
      case 'late':
        return 'Late Minutes';
      case 'earlyClose':
        return 'Early Close Minutes';
      case 'overtime':
        return 'Overtime Minutes';
      default:
        return 'Minutes';
    }
  };

  const getFieldValue = () => {
    if (!record) return '0';
    switch (type) {
      case 'late':
        return record.lateMinutes || '0';
      case 'earlyClose':
        return record.earlyCloseMinutes || '0';
      case 'overtime':
        return record.extraMinutes || '0';
      default:
        return '0';
    }
  };

  const getHrSignature = () => {
    if (!record) return null;
    const signatureField = `${type}HrSignature`;
    return record[signatureField] || null;
  };

  const getAdminSignature = () => {
    if (!record) return null;
    const signatureField = `${type}AdminSignature`;
    return record[signatureField] || null;
  };

  const isReasonSubmitted = () => {
    const reasonField = `${type}Reason`;
    return record && record[reasonField] && record[reasonField] !== '';
  };

  const isApproved = () => {
    const approvedField = `${type}Approved`;
    return record && record[approvedField];
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" className="custom-modal">
      <Modal.Header closeButton style={{ backgroundColor: '#007bff', color: 'white' }}>
        <Modal.Title>{getTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '20px' }}>
        <h4 style={{ marginBottom: '20px', color: '#0353a4' }}>{getTitle()}</h4>

        <Form.Group style={{ marginBottom: '15px' }}>
          <Form.Label><strong>Date:</strong></Form.Label>
          <Form.Control
            type="text"
            value={record ? new Date(record.date).toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' }) : ''}
            readOnly
          />
        </Form.Group>

        <Form.Group style={{ marginBottom: '15px' }}>
          <Form.Label><strong>Employee Name:</strong></Form.Label>
          <Form.Control
            type="text"
            value={record ? record.userName || '' : ''}
            readOnly
          />
        </Form.Group>

        <Form.Group style={{ marginBottom: '15px' }}>
          <Form.Label><strong>Department:</strong></Form.Label>
          <Form.Control
            type="text"
            value={record ? record.department || '' : ''}
            readOnly
          />
        </Form.Group>

        <Form.Group style={{ marginBottom: '15px' }}>
          <Form.Label><strong>{getFieldLabel()}:</strong></Form.Label>
          <Form.Control
            type="text"
            value={getFieldValue()}
            readOnly
          />
        </Form.Group>

        <Form.Group style={{ marginBottom: '15px' }}>
          <Form.Label><strong>Reason:</strong></Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={`Please explain the reason for your ${type === 'late' ? 'late arrival' : type === 'earlyClose' ? 'early departure' : 'overtime'}`}
            readOnly={isReasonSubmitted()}
            style={{ backgroundColor: isReasonSubmitted() ? '#f8f9fa' : 'white' }}
          />
          {isApproved() && (
            <p style={{ color: 'green', marginTop: '5px', marginBottom: '0' }}>
              <strong>Status:</strong> Approved by Admin
            </p>
          )}
        </Form.Group>

        <div style={{ marginTop: '30px', paddingBottom: '15px' }}>
          <h5>Approval Signatures</h5>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
            <div style={{ width: '30%', textAlign: 'center' }}>
              <p><strong>HR Signature</strong></p>
              <div style={{ minHeight: '30px', marginTop: '5px' }}>
                {getHrSignature() && <p style={{ fontStyle: 'italic', marginBottom: '5px' }}>{getHrSignature()}</p>}
              </div>
              <div style={{ borderTop: '1px solid #000' }}></div>
            </div>
            <div style={{ width: '30%', textAlign: 'center' }}>
              <p><strong>Admin</strong></p>
              <div style={{ minHeight: '30px', marginTop: '5px' }}>
                {getAdminSignature() && <p style={{ fontStyle: 'italic', marginBottom: '5px' }}>{getAdminSignature()}</p>}
              </div>
              <div style={{ borderTop: '1px solid #000' }}></div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: '#f1f1f1' }}>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        {!isReasonSubmitted() && (
          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ReasonModal;